const LoaderGeneric = () => (
  <div className="wishlist-loader wishlist-loader-generic">
    <span className="wishlist-loader-message">
      Carregando...
    </span>
  </div>
)

export default LoaderGeneric
